import { screeningAction } from 'src/redux/actions/constant';

const {
  POST_SCREENING_SUBMISSION_SUCCESS,
  POST_SCREENING_SUBMISSION_FAILURE,
  POST_SCREENING_SUBMISSION_LOADER,
  POST_SCREENING_SUBMISSION_REQUEST,
  POST_SCREENING_SUBMISSION_RESET,
} = screeningAction;

const intitialstate: object = {
  isScreeningSubmission: false,
  response: null,
  loader: false,
};

export const postScreeningSubmissionReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case POST_SCREENING_SUBMISSION_SUCCESS: {
      return {
        ...state,
        isScreeningSubmission: true,
        response: action.payload,
        loader: false,
      };
    }

    case POST_SCREENING_SUBMISSION_FAILURE:
      return {
        ...state,
        isScreeningSubmission: false,
        loader: false,
        response: action.payload,
      };

    case POST_SCREENING_SUBMISSION_LOADER:
      return {
        ...state,
        loader: true,
      };

    case POST_SCREENING_SUBMISSION_RESET:
      return intitialstate;

    default:
      return state;
  }
};
